import React from 'react';

type DashboardEmptyStateProps = {
  message: string;
  onRetry?: () => void;
};

export function DashboardEmptyState({ message, onRetry }: DashboardEmptyStateProps) {
  return (
    <div className="rounded-xl border border-app-border bg-app-surface p-8 text-center shadow-sm">
      <p className="text-sm text-app-text-muted">{message}</p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-4 inline-flex items-center rounded-lg border border-app-border bg-app-surface px-3 py-1.5 text-xs font-medium text-app-text-muted hover:bg-app-hover"
        >
          Erneut laden
        </button>
      ) : null}
    </div>
  );
}
